const pubYearDefaults = {
  start: 1800,
  end: new Date().getFullYear(),
};

let pubTypeValues = []; // [] means "no pub type filter" (i.e., All)
let appliedPubYearRange = null; // {start, end} | null

let savedCheckboxStates = {}; // { [value]: boolean }
let savedPubYearRange = { ...pubYearDefaults };

export function getPubYearDefaults() {
  return { ...pubYearDefaults };
}

export function getPubTypeValues() {
  return pubTypeValues;
}

export function setPubTypeValues(values) {
  pubTypeValues = Array.isArray(values) ? values : [];
}

export function getAppliedPubYearRange() {
  return appliedPubYearRange;
}

export function setAppliedPubYearRange(rangeOrNull) {
  appliedPubYearRange = rangeOrNull || null;
}

export function getSavedCheckboxStates() {
  return savedCheckboxStates;
}

export function setSavedCheckboxStates(states) {
  savedCheckboxStates = states && typeof states === "object" ? states : {};
}

export function getSavedPubYearRange() {
  return savedPubYearRange;
}

export function setSavedPubYearRange(range) {
  savedPubYearRange = range && typeof range === "object" ? range : { ...pubYearDefaults };
}

export function isAnyFilterApplied() {
  return getPubTypeValues().length > 0 || Boolean(getAppliedPubYearRange());
}

